import hasKey from './hasKey';
import type { Class, ClassInstance, TypeMap, TypeOf } from './isType';
import isType from './isType';

function hasTypedKey<O, K extends string, T extends TypeOf>(
  obj: O,
  key: K,
  type: T,
): obj is O & Record<K, TypeMap[T]>;
function hasTypedKey<O, K extends string, C extends Class>(
  obj: O,
  key: K,
  type: C,
): obj is O & Record<K, ClassInstance<C>>;
function hasTypedKey<T, K extends string>(
  obj: T,
  key: K,
  type: TypeOf | Class,
): boolean {
  return hasKey(obj, key) && isType(obj[key], type as TypeOf);
}

export default hasTypedKey;
